import { createSlice } from '@reduxjs/toolkit'

import { isFulfilledOpeningHoursAction } from './helpers'
import { InitialOpeningHoursState } from './interfaces'

const initialState: InitialOpeningHoursState = {
  isLoading: true,
  locationIds: [],
  openingHoursInfo: [],
  productLocationOpeningHours: [],
}

export const openingHoursSlice = createSlice({
  name: 'openingHoursSlice',
  initialState,
  reducers: {
    purgeOpeningHoursLists: (state) => {
      state.isLoading = true
      state.locationIds = []
      state.productLocationOpeningHours = []
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(isFulfilledOpeningHoursAction, (state, action) => {
      state.openingHoursInfo = action.payload.openingHours

      for (const info of action.payload.openingHours) {
        state.locationIds.push(info.locationId)
        state.productLocationOpeningHours[info.locationId] = info.openingHours
      }
      state.isLoading = false
    })
  },
})

export const { purgeOpeningHoursLists } = openingHoursSlice.actions

export default openingHoursSlice.reducer
